module.exports = __webpack_public_path__ + "static/media/hacktech.204a03b8.jpg";